module.exports = __webpack_public_path__ + "static/media/solar-system.1e356bfe.svg";